<template lang="jade">
  div.Button-group
    component(v-for='field in fdata.content'
              ":is"='field.type'
              ":fdata.sync"='field')
</template>

<script>
  export default{
    data () {
      return {
        uid: this.$parent.uid,
        show: true
      }
    },
    props: ['fdata']
  }
</script>



// WEBPACK FOOTER //
// group.vue?c4940144